import { CASSubtypes } from '../../../cimsPage/instances/cas'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const subtypes = CreateViewEditSoftRemoveRestore({
  object: 'Subtype',
  page: CASSubtypes,
  create: '52d6cb52-9b7c-4d2d-8f3b-420a0cab0253',
  view: '14dc4586-1f6e-4449-a35b-f2368442e80f',
  edit: '19054a5c-5d63-4e13-9692-cc62f0a25e36',
  removeRestore: 'c7352f99-e077-4375-8a1b-002174ece61d',
})

export const CreateCASSubtype = subtypes.Create
export const ViewCASSubtype = subtypes.View
export const EditCASSubtype = subtypes.Edit
export const RemoveRestoreCASSubtype = subtypes.RemoveRestore

export type CASSubtypePermission =
  | typeof CreateCASSubtype
  | typeof ViewCASSubtype
  | typeof EditCASSubtype
  | typeof RemoveRestoreCASSubtype
